import AboutMain from "../components/aboutMe/aboutLayout";
import PageTitle from "../components/PageTitle/PageTitle";

const AboutMe = ()=>{
    return(
        <>
        <div>
        <PageTitle title="About me" description="Curious | disciplined | coder | builder | learner | analytical | creative | resilient"/>
        <AboutMain/>
        </div>
        </>

    )
}

export default AboutMe;